import {createAction} from '@reduxjs/toolkit';

export const byName = createAction('FILTER_BY_NAME');
export const byType = createAction('FILTER_BY_TYPE');
export const setTypesFilter = createAction('SET_TYPES_FILTER');
